import React from "react";
import "./homeSections.css";

const AboutSection = () => {
  return (
    <section className="home-section about-section">
      <div className="container">

        <h2>About ShareVideo</h2>

        <p>
          ShareVideo is a multi-format digital content platform where creators
          can upload videos, short clips, music performances, audio songs,
          and photo posts to connect with a growing online audience. The
          platform is designed to support entertainers, musicians,
          educators, photographers, and independent digital creators.
        </p>

        <p>
          Users can explore full-length videos, short vertical content,
          devotional songs, dance performances, educational tutorials,
          standalone audio tracks, and creative image posts � all in one
          unified platform. ShareVideo enables creators to publish diverse
          content formats while building their personal brand.
        </p>

        <h3>Supported Content Formats</h3>

        <p>
          Creators can upload:
        </p>

        <ul>
          <li>Full-length videos</li>
          <li>Short vertical videos (Shorts)</li>
          <li>Music videos and song performances</li>
          <li>Audio-only songs and sound tracks</li>
          <li>Photo and image-based posts</li>
        </ul>

        <h3>How ShareVideo Works</h3>

        <p>
          After registration, creators can upload content using an easy
          dashboard interface. Once published, content becomes discoverable
          through the homepage, category sections, and personalized
          recommendations. Viewers can watch, listen, and engage with
          content across different formats.
        </p>

        <h3>Monetization Through Impressions</h3>

        <p>
          ShareVideo offers an impression-based earning system. Creators can
          generate revenue based on the visibility and engagement their
          content receives. The platform promotes original, high-quality,
          and community-friendly content to ensure sustainable growth.
        </p>

        <h3>Our Mission</h3>

        <p>
          Our mission is to create a transparent and creator-focused ecosystem
          that supports video creators, musicians, audio artists, and visual
          storytellers. We encourage originality, responsible publishing,
          and a safe digital environment for content discovery.
        </p>

      </div>
    </section>
  );
};

export default AboutSection;